<div class="counter" [attr.data-style]="style()">
  <button
    type="button"
    class="counter__button counter__button--decrement"
    [disabled]="isDisabled()"
    (click)="onDecrementClick()"
  >
    @if (removable() && value() <= min()) {
      <i class="counter__button_label icon icon-trash"></i>
    } @else {
      <span class="counter__button_label"> - </span>
    }
  </button>

  <div class="counter__control">
    <input
      type="number"
      class="counter__control_input"
      [min]="min()"
      [max]="max()"
      [(ngModel)]="value"
      (input)="onInput($event)"
      (focusout)="test($event)"
      [disabled]="isDisabled()"
    />
  </div>

  <button
    type="button"
    class="counter__button counter__button--increment"
    [disabled]="isDisabled()"
    (click)="onIncrementClick()"
  >
    <span class="counter__button_label"> + </span>
  </button>
</div>
